module.exports = __webpack_public_path__ + "fonts/TBCSailec-Light.ce0c231c.ttf";